<template>
    <div class="kgk-logout-form">
        <h2>Möchtest du dich wirklich abmelden?</h2>

        <button @click.prevent="performLogout">
            <i class="fas fa-sign-out-alt"></i>
            <span class="button-text">Abmelden</span>
        </button>

        <div v-if="loading" class="kgk-loading-indicator"><i class="fas fa-spinner fa-spin"></i></div>
        <div v-else-if="error">
            <p>Fehler: {{error}}</p>
        </div>
    </div>
</template>

<script>
    import sessionHandling from '../../session-handling';
    import session from '../../api/session';
    import router from '../../router';

    export default {
        name: 'LogoutForm',
        props: {
            //msg: String
        },
        data() {
            return {
                loading: false,
                error: false,
                user: '',
                password: ''
            }
        },
        mounted() {

        },
        methods: {
            performLogout: function() {
                this.loading = true;

                session.logout(
                    this,
                    () => {
                        this.error = false;

                        sessionHandling.logout();
                        this.$parent.$parent.resetUserOnLogout();

                        this.$notify({
                            type: 'success',
                            title: 'Ausgeloggt',
                            text: 'Du hast dich erfolgreich abgemeldet.'
                        });

                        router.push('/');
                    },
                    () => {
                        this.error = 'Es ist ein Fehler aufgetreten.';

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein Fehler aufgetreten.',
                            text: 'Bitte versuch es erneut.'
                        });
                    },
                    () => this.loading = false,
                );
            }
        }
    }
</script>
